<template>
    <span class="highlighted-element"><slot></slot></span>
</template>

<script>
    // use slot to pass text for highlighting
    export default {
        name: 'AppHighlightedText'
    }
</script>

<style scoped lang="scss">
    @import '../../../global';

    .highlighted-element {
        color: $app-highlighted;
    }

</style>